import { spacerKeys } from '../theme';
export function isSeparatorValue(x) {
    return spacerKeys.includes(x);
}
//# sourceMappingURL=types.utilities.js.map